import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-semibold text-gray-700" }, "Registro Accessi"),
  /*#__PURE__*/_createElementVNode("h3", null, "Impostazioni di sicurezza")
], -1)
const _hoisted_3 = { class: "flex justify-center my-4" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "px-4 py-2 text-gray-600" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "ml-2 mt-2 relative w-full overflow-x-auto shadow-md sm:rounded-lg" }
const _hoisted_8 = { class: "table-fixed w-full text-sm text-left text-gray-500 dark:text-gray-400" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", { class: "accessColor" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Data e Ora"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Dispositivo"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "IP")
  ])
], -1)
const _hoisted_10 = { scope: "row" }

import { ref, onMounted, computed } from 'vue';
import { patientStore } from "@/store/patient";

const pageSize = 10;


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistroAccessi',
  setup(__props) {

const store = patientStore();

const loginLogs = ref([]);

const currentPage = ref(1);
onMounted(async () => {
    await fetchData();
});

const fetchData = async () => {
    await store.fetchSecuritySettings();
    loginLogs.value = store.patient.loginLogs;
};

const totalPages = computed(() => Math.ceil(loginLogs.value.length / pageSize));

const paginatedLogs = computed(() => {
    const startIndex = (currentPage.value - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return loginLogs.value.slice(startIndex, endIndex);
});

const prevPage = () => {
    currentPage.value--;
};

const nextPage = () => {
    currentPage.value++;
};


function formatDateTime(date, time) {
    return `${date} ${time}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: prevPage,
        disabled: currentPage.value === 1,
        class: "px-4 py-2 bg-gray-200 text-gray-600 rounded-md cursor-pointer"
      }, "Previous", 8, _hoisted_4),
      _createElementVNode("span", _hoisted_5, _toDisplayString(currentPage.value), 1),
      _createElementVNode("button", {
        onClick: nextPage,
        disabled: currentPage.value === totalPages.value,
        class: "px-4 py-2 bg-gray-200 text-gray-600 rounded-md cursor-pointer"
      }, "Next", 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("table", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedLogs.value, (log) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: log.id_audit,
              class: "accessColor"
            }, [
              _createElementVNode("td", _hoisted_10, _toDisplayString(formatDateTime(log.audit_data, log.audit_time)), 1),
              _createElementVNode("td", null, _toDisplayString(log.dispositivo), 1),
              _createElementVNode("td", null, _toDisplayString(log.audit_ip), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})